import React, {useState, useEffect, useContext} from 'react'
import styled from 'styled-components';
import { history } from '../../_helpers'
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import './SignIn.scss'
import { rankOptions, abilityOptions, fieldOptions, SMfieldOptions, ITfieldOptions, BMfieldOptions, freshOptions, interestOptions, SMjobOptions, ITjobOptions, BMjobOptions, tagOptions, languageOptions, schoolOptions, majorOptions, degreeOptions, companyOptions, paperOptions, lookOptions, yearOptions, monthOptions } from '../SignIn/data';
import {UserContext} from "../../context/context"

import {Link} from 'react-router-dom';

function SignIn(props) {
  // const [data, setData] = useState(null)

  const [state, actions] = useContext(UserContext);
  
  const [page, setPage] = useState(0)
  
  const [field, setField] = useState()
  const [job, setJob] = useState()
  const [fresh, setFresh] = useState()

  const [work, setWork] = useState()

  const [whichjobOptions, setWhichjobOptions] = useState(SMjobOptions)

  // const [schoolNum , setSchoolNum] = useState([0])
  const [title, setTitle] = useState([]) // 어레이로 해서 순서대로 post 해야할듯?
  const [major, setMajor] = useState([])
  const [degree, setDegree] = useState([])
  const [prof, setProf] = useState([])
  const [paper, setPaper] = useState([])
  const [startY, setStartY] = useState([])
  const [startM, setStartM] = useState([])
  const [endY, setEndY] = useState([])
  const [endM, setEndM] = useState([])

  // Abilities and Interests
  
  const [abilities, setAbilities] = useState([])
  const [interests, setInterests] = useState([])
  const [tag, setTag] = useState([])
  const [domain, setDomain] = useState([])

  const [lookjob, setLookjob] = useState()
  const [lookcons, setLookcons] = useState()

  const [realname, setRealname] = useState()
  const [realmail, setRealmail] = useState()
  const [realbirth, setRealbirth] = useState()
  const [realphone, setRealphone] = useState()

  const [authbtn, setAuthbtn] = useState(false)
  const [authnum, setAuthnum] = useState()
  // const [authchk, setAuthchk] = useState(false)


  let user = JSON.parse(String(localStorage.getItem('user')))
  // console.log(user)

  // let email = String(localStorage.getItem('email'))
  // console.log(email)
  
  const header = {
    'Authorization': `JWT ${user.token}`,
    // 'Authorization': `JWT ${state.token}`,
    'Content-Type': 'application/json'
  }

  useEffect(()=>{

  })

  const removeJob = (option) => {
    let newSelect = job
    
    if(job && job.length){
      job.map((item, index)=>{
        if(!option.includes({value: item, label: item})){
          newSelect = []
        }
      })
      setJob(newSelect)
    }
  };

  function fetchPage000(){

    fetch(state.awslink + "/user/userReal/", {
      method: 'POST',
      headers: header,
      body:JSON.stringify({
        "realname": realname || null,
        "realmail": realmail || null,
        "realbirth": realbirth || null,
        "realphone": realphone || null
      })
    })
    .then(response => response.json())
    .then(json=>{})
  }
  

  function fetchPage0(){
    console.log(field, job, fresh)

    fetch(state.awslink + "/user/userBasic/", {
      method: 'POST',
      headers: header,
      body:JSON.stringify({
        "field": field,
        "job": job,
        "fresh": fresh
      })
    })
    .then(response => response.json())
    .then(json=>{})
  }

  function fetchPage1(index){
    console.log(index, title, major, degree, prof, paper, startY, startM, endY, endM)
    fetch(state.awslink + "/user/school/", {
      method: 'POST',
      headers: header,
      body:JSON.stringify({
        "title": title[index],
        "major": major[index],
        "degree": degree[index],
        "prof": prof[index] || null,
        "paper": paper[index] || null,
        "start": startY[index] + "/" + startM[index],
        "end": endY[index] + "/" + endM[index] || null,
      })
    })
    .then(response => response.json())
    .then(json=>{})
  }

  function fetchPage2(){
    console.log(abilities, interests, tag)
    fetch(state.awslink  + "/user/userIntAbi/", {
      method: 'POST',
      headers: header,
      body:JSON.stringify({
        "abilities": abilities,
        "interests": interests,
        "tag": tag,
        "domain" : domain,
      })
    })
    .then(response => response.json())
    .then(json=>{})

    fetch(state.awslink  + "/user/userBasic/", {
      method: 'PUT',
      headers: header,
      body:JSON.stringify({
        "lookjob": lookjob,
        "lookcons": lookcons,
      })
    })
    .then(response => response.json())
    .then(json=>{})

  }

  // console.log(props.token, state.token)


  function handleDefault(index) {
    let tempObj=[];
    if(index)
      index.map((item)=>{tempObj.push({value:item, label:item})})
    return(tempObj)
  }


  const arraySet = (index, tag) => e =>{
    let newArr = [...tag]
  
    if(tag === title)        {newArr[index] = e.value; setTitle(newArr)}
    else if(tag === major)   {newArr[index] = e.value; setMajor(newArr)}
    else if(tag === degree)   {newArr[index] = e.value; setDegree(newArr)}
    else if(tag === prof)   {newArr[index] = e.target.value; setProf(newArr)}
    else if(tag === paper)   {newArr[index] = e.target.value; setPaper(newArr)}
    else if(tag === startY)  {newArr[index] = e.target.value; setStartY(newArr)}
    else if(tag === startM)  {newArr[index] = e.target.value; setStartM(newArr)}
    else if(tag === endY)    {newArr[index] = e.target.value; setEndY(newArr)}
    else if(tag === endM)    {newArr[index] = e.target.value; setEndM(newArr)}

  }

  const handleChange = (func) => e => {
    func(Array.isArray(e) ? e.map(x => x.value) : [])
  }

  function yearSelectorStart(index, y, m){
    return(
      <YearWrapper>
        <Select
          className="profile-basic-date"
          defaultValue={null}
          isSearchable={true}
          name="color"
          options={yearOptions}
          onChange={(e)=>{
            arraySet(index, startY)
          }}
        />
        <Select
          className="profile-basic-date-month"
          defaultValue={null}
          isSearchable={true}
          name="color"
          options={monthOptions}
          onChange={(e)=>{
            arraySet(index, startM)
          }}
        />
      </YearWrapper>
      )
  }  

  function yearSelectorEnd(index, y, m){
    return(
      <YearWrapper>
        <Select
          className="profile-basic-date"
          defaultValue={null}
          isSearchable={true}
          name="color"
          options={yearOptions}
          onChange={(e)=>{
            arraySet(index, endY)
          }}
        />
        <Select
          className="profile-basic-date-month"
          defaultValue={null}
          isSearchable={true}
          name="color"
          options={monthOptions}
          onChange={(e)=>{
            arraySet(index, endM)
          }}
        />
      </YearWrapper>
      )
  }  

  function schoolForm(index){
    console.log(index); 
    // console.log(i)
    return(
      <SignInForm>
        <span>
          <div>
            학교이름
            <CreatableSelect
              className="signin-basic-single"
              defaultValue={null}
              isSearchable={true}
              name="color"
              options={schoolOptions}
              onChange={arraySet(index, title)}
              // onInputChange={arraySet(index, title)}
                // setTitle(e.value)}}
            />
          </div>
        </span>
        <span>
          <div>
            전공
          <Select
              className="signin-basic-single"
              defaultValue={null}
              isSearchable={true}
              name="color"
              options={majorOptions}
              onChange={arraySet(index, major)}
            />
          </div>
        </span>
            
        <span>
          <div>
            학위
            <Select
              className="signin-basic-single"
              defaultValue={null}
              isSearchable={true}
              name="color"
              options={degreeOptions}
              onChange={arraySet(index, degree)}
            />
          </div>
        </span>
            
            {degree[index]==="학사 과정" || degree[index]==="학사 졸업" || degree[index] === undefined ?
            null: 
            <span>
              <div>
                지도교수
              <input className="basic-input" value={prof[index]} onChange={arraySet(index, prof)}/>
              </div>
            </span>  
            
            }
            <span>
              <div>
                연구주제
              <input className="basic-input" value={paper[index]} onChange={arraySet(index, paper)}/>
              </div>
            </span>
            
            {degree[index]==="학사 과정" || degree[index]==="석사 과정" || degree[index] === "박사(통합) 과정" || degree[index] === undefined ?
            <>
            {/* <YearWrapper>
              <input className="basic-input" style={{width: 80}} value={startY[index]} onChange={arraySet(index, startY)}/>
              <input className="basic-input" style={{width: 50}} value={startM[index]} onChange={arraySet(index, startM)}/>
            </YearWrapper> */}

            {yearSelectorStart(index, startY, startM)}
            {/* {yearSelectorEnd(setEndY, setEndM, endY, endM)} */}
            </>
            :
            
            <>
            {yearSelectorStart(index, startY, startM)}
            {yearSelectorEnd(index, endY, endM)}
            {/* <YearWrapper>
              <input className="basic-input" style={{width: 80}} value={startY[index]} onChange={arraySet(index, startY)}/>
              <input className="basic-input" style={{width: 50}} value={startM[index]} onChange={arraySet(index, startM)}/>
            </YearWrapper>
            <YearWrapper>
              <input className="basic-input" style={{width: 80}} value={endY[index]} onChange={arraySet(index, endY)}/>
              <input className="basic-input" style={{width: 50}} value={endM[index]} onChange={arraySet(index, endM)}/>
            </YearWrapper> */}
            </>
            }
          </SignInForm>
    )
  }

  function fetchAuthPost(){
    fetch(state.awslink + "/api/auth/", {
      method: 'POST',
      headers: header,
      body:JSON.stringify({
        "phone_number": realphone,
      })
    })
    .then(response => response.json())
    .then(json=>{})
  }

  function fetchAuthPut(){
    fetch(state.awslink + "/api/auth/", {
      method: 'PUT',
      headers: header,
      body:JSON.stringify({
        "phone_number": realphone,
        "auth_number": parseInt(authnum)
      })
    })
    .then(response => response.json())
    .then((result) => {
      console.log('Success:', result);
      // setSelectedFile()
      // window.location.reload()
    })
    .catch((error) => {
      console.error('Error:', error);
      window.confirm("인증 번호가 틀렸습니다. 다시 확인해주세요.")
    });
  }
  // console.log(title, major, degree, prof, paper, startY, startM, endY, endM)
  console.log(fresh)

  return(
    <Wrapper>
      <SignInWrapper>
        {page}

        {page === 0 && 
        <>
          <SignInForm>
            <span>
              <div>
                실명
                <input className="basic-input" value={realname} onChange={(e)=>setRealname(e.target.value)}/>
              </div>
            </span>
            <span>
              <div>
                이메일
                <input className="basic-input" value={realmail} onChange={(e)=>setRealmail(e.target.value)}/>
              </div>
            </span>

            <span>
              <div>
                출생년도
                <Select
                  className="signin-basic-single"
                  defaultValue={null}
                  isSearchable={true}
                  name="color"
                  options={yearOptions}
                  onChange={(e)=>{if(e.value) setRealbirth(e.value)}}
                />
              </div>
            </span>
            
            <span>
              <div>
                휴대폰 인증
                <input className="basic-input" 
                placeholder="- 제외한 숫자만 입력" value={realphone} onChange={(e)=>setRealphone(e.target.value)}/>
              </div>
              
              <button onClick={()=>{fetchAuthPost(); setAuthbtn(true)}}>
                {authbtn === false ?  "번호받기":"다시받기"}
              </button>

              {authbtn ?
              <>
              <input 
              className="basic-input" 
              
              value={authnum} onChange={(e)=>setAuthnum(e.target.value)}/>
              <button disabled={!authnum} onClick={()=>{fetchAuthPut()}}>
                보내기
              </button>
              </>

              :null}

            </span>
            
            
          </SignInForm>
          <button 
          // disabled={!authnum||!realname||!realphone} 
          onClick={()=>{
            setPage(page+1); 
            fetchPage000()
            }}>
            다음
          </button>
        </>
        }

        {/* Basic info */}
        {page === 1 && 
        <>
          <SignInForm>
            <span>
              <div>
                직군
                <Select
                  className="signin-basic-single"
                  defaultValue={null}
                  isSearchable={true}
                  name="color"
                  options={fieldOptions}
                  onChange={(e)=>{
                    if(e.value) {
                      setField(e.value)
                      if(SMfieldOptions.filter((item)=>item.value === e.value).length){
                        let index = SMfieldOptions.findIndex((item)=>item.value===e.value)
                        setWhichjobOptions(SMjobOptions[index])
                        removeJob(SMjobOptions[index])
                      }
                      else if(ITfieldOptions.filter((item)=>item.value === e.value).length){
                        let index = ITfieldOptions.findIndex((item)=>item.value===e.value)
                        setWhichjobOptions(ITjobOptions[index])
                        removeJob(ITjobOptions[index])
                      }
                      else if(BMfieldOptions.filter((item)=>item.value === e.value).length){
                        let index = BMfieldOptions.findIndex((item)=>item.value===e.value)
                        setWhichjobOptions(BMjobOptions[index])
                        removeJob(BMjobOptions[index])
                      } 
                    }
                  }}
                />
              </div>
            </span>
            <span>
              <div>
                직무
                <Select
                  // className="basic-single"
                  defaultValue={null}
                  className="signin-basic-multi"
                  isMulti
                  isSearchable={true}
                  name="color"
                  options={whichjobOptions}
                  value={handleDefault(job)}
                  onChange={(e)=>{setJob(Array.isArray(e) ? e.map(x => x.value) : [])}}
                />
              </div>
            </span>

            <span>
              <div>
                기술/도구
                <CreatableSelect
                  defaultValue={null}
                  className="signin-basic-multi"
                  isMulti
                  options={abilityOptions}
                  onChange={handleChange(setAbilities)}
                />
              </div>
            </span>
            
            <span>
              <div>
                신입/경력
                <Select
                  className="signin-basic-single"
                  defaultValue={null}
                  isSearchable={true}
                  name="color"
                  options={freshOptions}
                  onChange={(e)=>{if(e.value) setFresh(e.value)}}
                />
              </div>
            </span>
            
            {!fresh || fresh === "신입(학생)"?
            null:
            <span>
              <div>
                회사이름
              <Select
                  className="signin-basic-single"
                  defaultValue={null}
                  isSearchable={true}
                  name="color"
                  options={companyOptions}
                  onChange={(e)=>{if(e.value) setWork(e.value)}}
                />
              </div>
            </span> 
            }

            
          </SignInForm>
          <button disabled={!field||!job} onClick={()=>{
            setPage(page+1); 
            fetchPage0()
            }}>
            다음
          </button>
        </>
        }
        {/* School Info */}
        {page === 2 && 
        <>
          {/* {schoolNum.map((value, index)=>{ return(schoolForm(index, schoolNum.length))})}
          {schoolNum.length < 2 ?
          <button onClick={()=>{
            setSchoolNum(oldArray => [...oldArray, 0])
            }}>
            더보기
          </button>
          : null} */}
          {schoolForm(0)}
          
          <button onClick={()=>{
            setPage(page+1); 
            fetchPage1(0)
            // {schoolNum.map((value, index)=>{ return(fetchPage1(index))})}
            
            }}>
            다음
          </button>
        </>
        }

        {page === 3 && 
        <>
          <SignInForm>
            <div>
              도메인
              <Select
                defaultValue={null}
                className="signin-basic-multi"
                isMulti
                options={interestOptions}
                onChange={handleChange(setDomain)}
              />
            </div>
            
            <div>
              관심분야
              <Select
                defaultValue={null}
                className="signin-basic-multi"
                isMulti
                options={interestOptions}
                onChange={handleChange(setInterests)}
              />
            </div>
            
            <div>
              태그
              <Select
                defaultValue={null}
                className="signin-basic-multi"
                isMulti
                options={tagOptions}
                onChange={handleChange(setTag)}
              />
            </div>
            <div>
              리크루터 공개
              <Select
                defaultValue={null}
                className="signin-basic-multi"
                options={lookOptions}
                onChange={(e)=>setLookjob(e.value)}
              />
            </div>
            <div>
              자문 공개
            <Select
              defaultValue={null}
              className="signin-basic-multi"
              options={lookOptions}
              onChange={(e)=>setLookcons(e.value)}
            />
            </div>

          </SignInForm>
          <button onClick={()=>{
              fetchPage2(); history.push('/profile');
            }}>
            다음
          </button>
        </>
        }

        <Link to={'/'}>
          나중에 하기
        </Link>
      </SignInWrapper>
    </Wrapper>   
  )
}

export default SignIn;

const Wrapper = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;

  background-color: rgba(0,0,0,0.1);
`
const SignInWrapper = styled.div`
  display: flex;
  width: 400px;
  height: 600px;
  justify-content: center;
  align-items: center;

  background-color: white;
  border-radius: 5px;

  flex-direction: column;
`
const SignInForm = styled.div`
  display: flex;
  width: 100%;
  min-width: 390px;
  height: 490px;
  justify-content: center;
  align-items: center;

  background-color: white;
  border-radius: 5px;

  flex-direction: column;

  > span{
    /* background-color: red; */
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: row;
    margin-bottom: 5px;

    > div{
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
      /* :last-child{
        position: absolute;
        left: 50%;
      } */
      
      
    }
  }
`
const YearWrapper=styled.div`
  display: flex;
  flex-direction: row;
`